import React from "react";
import Step1 from "../steps/section-7/step-1";
import Step2 from "../steps/section-7/step-2";
import Step3 from "../steps/section-7/step-3";
import Step4 from "../steps/section-7/step-4";
import Step5 from "../steps/section-7/step-5";

function TeamReportsSection7({
  step = 1,
  incomeStatement,
  balanceSheet,
  cashFlow,
  current_year = 0
}) {
  if (step === 1) {
    return <Step1 />;
  }

  if (step === 2) {
    return (
      <Step2 incomeStatement={incomeStatement} current_year={current_year} />
    );
  }

  if (step === 3) {
    return <Step3 balanceSheet={balanceSheet} current_year={current_year} />;
  }

  if (step === 4) {
    return <Step4 cashFlow={cashFlow} current_year={current_year} />;
  }

  if (step === 5) {
    return <Step5 />;
  }

  return null;
}

export default TeamReportsSection7;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-7.js